import React, { useState } from "react";
import dayjs from "dayjs";
import {
  LocalizationProvider,
  DatePicker,
  DesktopDatePicker,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Skeleton,
  Paper
} from "@mui/material";

/* ---- TABLE SKELETON ---- */
export const ThemeTableSkeleton = ({ tableHeaders }) => (
  <TableContainer component={Paper}>
    <Table>
      <TableHead>
        <TableRow>
          {tableHeaders.map((_, i) => (
            <TableCell key={i}>
              <Skeleton width="70%" />
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {Array.from({ length: 12 }).map((_, idx) => (
          <TableRow key={idx}>
            {tableHeaders.map((_, i) => (
              <TableCell key={i}>
                <Skeleton width="80%" />
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);